import setupCarouselProjects from "./modules/CarouselProjects";
import setupCarouselStories from "./modules/CarouselStories";
import setupCarouselScroll from "./modules/CarouselScroll";
import setupCarouselIndustries from "./modules/CrouselIndustries";
import carouselFeatures from "./modules/CarouselFeatures";
import carouselProperties from "./modules/CarouselProperties";

export default function useCarousels() {
    setupCarouselProjects();
    setupCarouselStories();
    setupCarouselScroll();
    setupCarouselIndustries();
    carouselProperties.init();
    carouselFeatures.init();
}
